/* global __APP_VERSION__, __BUILT_AT__ */
import { useEffect, useState } from 'react';

/* The version baked into this build (from package.json at build time) and a
   check against /version.json, which every deploy publishes, so an app left
   open on a scanner learns that a newer build is waiting. */
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';
export const BUILT_AT = typeof __BUILT_AT__ !== 'undefined' ? __BUILT_AT__ : '';
export const SEEN_KEY = 'inny.seenVersion';

/** Semantic compare: 1 when a is newer than b, -1 when older, 0 when equal. */
export function compareVersions(a, b) {
  const pa = String(a || '0').split('.').map((n) => parseInt(n, 10) || 0);
  const pb = String(b || '0').split('.').map((n) => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d > 0 ? 1 : -1;
  }
  return 0;
}

const CHECK_EVERY = 10 * 60 * 1000;

/** The version of a newer deployed build, or null. Checks on load, every ten
    minutes, and each time the app comes back to the foreground. */
export function useUpdateCheck() {
  const [available, setAvailable] = useState(null);
  useEffect(() => {
    let live = true;
    const check = async () => {
      try {
        const r = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const info = await r.json();
        if (live && info?.version && compareVersions(info.version, APP_VERSION) > 0) setAvailable(info.version);
      } catch {
        /* offline or not deployed as a static build: no news */
      }
    };
    check();
    const timer = setInterval(check, CHECK_EVERY);
    const onVisible = () => document.visibilityState === 'visible' && check();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      live = false;
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
  return available;
}
